import React from 'react';
import { useSelector } from 'react-redux';
import { getClassLabelKey } from '../../../../../utils/utils';
import DropDown from '../../../../ui/dropDown/DropDown';
import classes from './StudentsTab.module.css';

const SelectClasses = ({ classesList = [], selectedClass, onClassChange }) => {
    
    const { texts } = useSelector(state => state.translate);
    const selectedItem = classesList.find(c => c?.classId === selectedClass?.classId && c?.ordinal === selectedClass?.ordinal);
    const dropdownValue =  `${texts?.class ?? ''} ${texts?.[getClassLabelKey(selectedItem?.classId)]}'${selectedItem?.ordinal}`;

    return (
        <div className={classes.dropdownWrapper}>
            <DropDown
                options={classesList.map(classItem => ({
                    key: `${classItem?.classId}-${classItem?.ordinal}`,
                    value: `${texts?.class ?? ''} ${texts?.[getClassLabelKey(classItem?.classId)]}'${classItem?.ordinal}`,
                    onClick: () => onClassChange?.({ classId: classItem.classId, ordinal: classItem.ordinal })
                }))}
                value={dropdownValue}
                showValue={true}
                dropClass={classes.classDropdown}
                arrowColor="#000"
                closeOnApply={true}
                applyButtonText={texts?.selectClass ?? ''}
                height="280px"
            />
        </div>
    );
};

export default SelectClasses;

